import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCompetency } from 'app/_models/competency.model';
import { CompetencyService } from 'app/_services/competency.service';
import { NotificationService } from 'app/_services/notification.service';
import DateTimeUtils from 'app/_utils/datetime.utils';
import { environment } from 'environments/environment';

@Component({
  selector: 'accept-competency-modal',
  templateUrl: './accept-competency-modal.component.html',
})
export class AcceptCompetencyModalComponent implements OnInit {
  @Input() competency: UserCompetency;
  @Input() siteOwnerId: number;

  public selectedDocument: File = null;
  public expiryDate: Date = null;
  public saveInProgress = false;
  public today: Date = new Date();
  private currentYear = new Date().getFullYear();
  public datepickerYearRange = this.currentYear + ':' + (this.currentYear + 10);

  constructor(
    private activeModal: NgbActiveModal,
    private competencyService: CompetencyService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    // Populate the expiry date from the competency model using the timeless-date helper
    const expiryDate = this.competency.expiryDate;

    this.expiryDate = typeof expiryDate === 'string'
      ? DateTimeUtils.timelessDateStrAsUTCDate(expiryDate)
      : expiryDate || null;
  }

  get hasExistingDocument(): boolean {
    return !!(this.competency && this.competency.documentFileName);
  }

  get requiresSupportingDocumentForApproval(): boolean {
    return this.siteOwnerId === environment.WFSO_OWNER_SKYLARK_ID;
  }

  get hasRequiredDocument(): boolean {
    return this.hasExistingDocument || !!this.selectedDocument;
  }

  public closeModal(): void {
    this.activeModal.dismiss();
  }

  public onFileSelected(event: any): void {
    this.selectedDocument = event.target.files[0] || null;
  }

  public accept(): void {
    if (this.saveInProgress || !this.expiryDate || this.isExpiryDateInPast || (this.requiresSupportingDocumentForApproval && !this.hasRequiredDocument)) {
      return;
    }

    this.saveInProgress = true;
    const expiryDateStr = DateTimeUtils.localDateToTimelessString(this.expiryDate);

    this.competencyService.approveCompetency(
      this.competency.id,
      this.siteOwnerId,
      expiryDateStr,
      this.selectedDocument
    ).subscribe(
      () => {
        this.notificationService.notify('success', 'Competency accepted');
        this.activeModal.close('refresh');
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error accepting competency');
        this.saveInProgress = false;
      }
    );
  }

  public get isExpiryDateInPast(): boolean {
    if (!this.expiryDate) {
      return false;
    }

    return DateTimeUtils.isDateExpired(this.expiryDate);
  }
}
